export const sliderTranslations = {
    prev: 'Vorherige Folie',
    next: 'Nächste Folie',
    play: 'Abspielen',
    Pause: 'Pause',
    first: 'Zur ersten Folie wechseln',
    last: 'Zur letzte Folie wechseln',
    slideX: 'Gehe zu Folie %s',
    slideLabel: 'Folie %s von %s',
    pageX: `Gehe zur Seite %s`,
    slide: 'Folie',
    slides: 'Folien',
    select: 'Wählen Sie eine Folie zum Anzeigen aus',
    autoplay: 'Automatisch abspielen',
    autoplayPause: 'Automatisches Abspielen pausieren',
    autoplayPlay: 'Automatisches Abspielen fortsetzen',
    carousel: 'Karussell',
    pagination: 'Paginierung'
};
